import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

interface StyledLinkProps {
  children: string
  className?: string
  to: string
}

export const StyledLink: React.FC<StyledLinkProps> = ({
  children,
  className,
  to,
}) => {
  return (
    <Link
      to={to}
      className={classNames('text-brand-6 underline text-lg', className)}
    >
      {children}
    </Link>
  )
}
